// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.showing-calendar-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: "Proxima Nova", sans-serif;
  animation: fadeIn 0.5s;
}
.showing-calendar-container .header {
  display: flex;
  align-items: center;
}
.showing-calendar-container .header > p {
  margin: 0;
  font-family: "Proxima Nova", sans-serif;
  font-weight: 700;
  color: var(--secondary-color-1);
  font-size: 20px;
  margin-left: 10px;
}
.showing-calendar-container .info {
  display: flex;
  align-items: center;
  justify-content: center;
}
.showing-calendar-container .info > p {
  font-family: "Proxima Nova", sans-serif;
  font-size: 16px;
  line-height: 24px;
  width: 800px;
  text-align: center;
  color: var(--secondary-color-1);
}
.showing-calendar-container .info > p > span {
  font-weight: 700;
  text-decoration: underline;
}
.showing-calendar-container .info > p > span.showing {
  color: #FAC91F;
}
.showing-calendar-container .info > p > span.blackout {
  color: var(--secondary-color-3);
}
.showing-calendar-container .event-container {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  column-gap: 4px;
}
.showing-calendar-container .event-container ::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  opacity: 0;
}
.showing-calendar-container .event-container:hover {
  /* Track */
  /* Handle */
  /* Handle on hover */
}
.showing-calendar-container .event-container:hover ::-webkit-scrollbar {
  opacity: 1;
}
.showing-calendar-container .event-container:hover ::-webkit-scrollbar-track {
  border-radius: 10px;
}
.showing-calendar-container .event-container:hover ::-webkit-scrollbar-thumb {
  background: #b4b4b4;
  border-radius: 10px;
}
.showing-calendar-container .event-container:hover ::-webkit-scrollbar-thumb:hover {
  background: #b4b4b4;
}
.showing-calendar-container .event-container .indicators {
  display: flex;
  align-items: center;
  flex-direction: column;
  bottom: 0;
  row-gap: 2px;
}
.showing-calendar-container .event-container .event-bubble {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  position: relative;
  row-gap: 4px;
  padding-left: 8px;
}
.showing-calendar-container .event-container .event-bubble .time {
  color: #5F5F5F;
  margin: 0;
  font-size: 12px;
}
.showing-calendar-container .event-container .event-bubble .detail {
  width: 100%;
  font-size: 12px;
  font-weight: 700;
  text-transform: capitalize;
  color: var(--secondary-color-1);
}
.showing-calendar-container .event-container .view {
  position: absolute;
  top: 3px;
  right: 2px;
  cursor: pointer;
  transition: 0.2s ease-in-out;
}
.showing-calendar-container .event-container .view:hover {
  opacity: 0.5;
}
.showing-calendar-container .calendars {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0px;
  font-family: "Proxima Nova", sans-serif;
  background-color: white;
}
.showing-calendar-container .calendars .past-cell {
  background-color: rgba(254, 242, 242, 0.2941176471) !important;
}
.showing-calendar-container .calendars .custom-toolbar {
  display: flex;
  height: 60px;
  justify-content: space-between;
  align-items: center;
  padding-right: 24px;
}
.showing-calendar-container .calendars .custom-toolbar .title {
  font-weight: 700;
  font-size: 16px;
  margin: 0;
}
.showing-calendar-container .calendars .custom-toolbar svg {
  cursor: pointer;
  transition: 0.2s ease-in-out;
}
.showing-calendar-container .calendars .custom-toolbar svg:hover {
  opacity: 0.75;
}
.showing-calendar-container .calendars .custom-toolbar .views {
  display: flex;
  padding: 4px;
  border-radius: 8px;
  background-color: #F9F9F9;
  font-size: 10px;
  font-weight: 400;
}
.showing-calendar-container .calendars .custom-toolbar .views > li {
  width: 78px;
  border-radius: 4px;
  background-color: inherit;
  padding: 8px 0;
  text-align: center;
  cursor: pointer;
  transition: 0.2s ease-in-out;
}
.showing-calendar-container .calendars .custom-toolbar .views > li:hover {
  opacity: 0.75;
}
.showing-calendar-container .calendars .custom-toolbar .views > li.active {
  background-color: var(--primary-color-1);
  color: white;
  font-weight: 700;
}
.showing-calendar-container .calendars .sb-fc {
  height: calc(100vh - 140px);
  position: relative;
}
.showing-calendar-container .calendars .sb-fc .loading {
  height: calc(100vh - 140px);
  width: 100%;
  z-index: 999;
  background-color: rgba(255, 255, 255, 0.368627451);
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
}
.showing-calendar-container .calendars .sb-fc table > thead {
  height: 54px;
}
.showing-calendar-container .calendars .sb-fc table > thead > tr > th {
  vertical-align: middle;
}
.showing-calendar-container .calendars .sb-fc .fc .fc-scrollgrid {
  overflow: hidden;
  border: none;
}
.showing-calendar-container .calendars .sb-fc .fc-daygrid-day-events {
  padding: 0 4px;
  display: flex;
  flex-direction: column;
  row-gap: 3px;
}
.showing-calendar-container .calendars .sb-fc .fc .fc-timegrid-slot-label-cushion {
  font-size: 12px;
  text-transform: uppercase;
  color: #949494;
  font-weight: 700;
}
.showing-calendar-container .calendars .sb-fc .fc .fc-timegrid-now-indicator-arrow {
  border-color: #EF4546;
  border-top-color: transparent;
  border-bottom-color: transparent;
  margin-top: -6px;
  border-width: 7px 0 7px 8px;
}
.showing-calendar-container .calendars .sb-fc .fc .fc-timegrid-now-indicator-line {
  border-color: #EF4546;
  border-width: 2px 0 0;
  position: relative;
  display: flex;
  align-items: center;
}
.showing-calendar-container .calendars .sb-fc .fc .fc-timegrid-now-indicator-line::before {
  content: "";
  position: absolute;
  height: 8px;
  width: 8px;
  border-radius: 100px;
  background-color: #EF4546;
}
.showing-calendar-container .calendars .sb-fc .fc-theme-standard th {
  border: 1px solid #F5F5F5;
  border-bottom: none;
}
.showing-calendar-container .calendars .sb-fc .fc-theme-standard td {
  border: 1px solid #F5F5F5;
  border-top: none;
  height: 40px;
}
.showing-calendar-container .calendars .sb-fc .fc td.fc-day-disabled {
  background: white;
}
.showing-calendar-container .calendars .sb-fc .fc th.fc-day-disabled {
  background: #F5F5F5;
}
.showing-calendar-container .calendars .sb-fc .fc .fc-daygrid-day-top {
  padding: 10px 0;
  justify-content: center;
}
.showing-calendar-container .calendars .sb-fc .fc-left > .fc-button-group {
  background: #FFFFFF;
  padding: 5px 2px;
  border: 1px solid #FAC91F;
  border-radius: 10px;
  align-content: space-between;
}
.showing-calendar-container .calendars .sb-fc .fc .fc-header-toolbar .fc-toolbar-chunk:first-child .fc-button-group {
  padding: 4px 5px;
  background: white;
  border-radius: 10px;
}
.showing-calendar-container .calendars .sb-fc .fc-toolbar.fc-header-toolbar {
  background-color: white;
}
.showing-calendar-container .calendars .sb-fc .fc-center h2 {
  color: #FFFFFF;
  font-size: 25px;
}
.showing-calendar-container .calendars .sb-fc .fc-button-primary:not(:disabled).fc-button-active,
.showing-calendar-container .calendars .sb-fc .fc-button-primary:not(:disabled):active {
  background: #FAC91F;
  border: 0;
  color: white;
}
.showing-calendar-container .calendars .sb-fc .fc-button-group > .fc-button {
  background: #FFFFFF;
  color: #BEBEBE;
  border-radius: 10px !important;
  border: 0;
  font-weight: bold;
  text-transform: capitalize;
  padding: 6px 18px;
  transition: 0.3s ease-in-out;
}
.showing-calendar-container .calendars .sb-fc .fc-right > .fc-button-group > .fc-button {
  padding: 7px;
}
.showing-calendar-container .calendars .sb-fc .fc-right > .fc-button-group > .fc-button-primary {
  background: #FFFFFF;
}
.showing-calendar-container .calendars .sb-fc .fc-right > .fc-button-group > .fc-button-primary:disabled {
  color: #BEBEBE;
}
.showing-calendar-container .calendars .sb-fc .fc-prev-button {
  margin-right: 20px;
}
.showing-calendar-container .calendars .sb-fc .fc-right .fc-button:disabled {
  opacity: 0.3;
}
.showing-calendar-container .calendars .sb-fc .fc-right .fc-button {
  opacity: 0.65;
}
.showing-calendar-container .calendars .sb-fc .fc-button-primary:not(:disabled).fc-button-active:focus,
.showing-calendar-container .calendars .sb-fc .fc-button-primary:not(:disabled):active:focus {
  box-shadow: none;
}
.showing-calendar-container .calendars .sb-fc .fc-button-group > .fc-button:not(:last-child) {
  margin-right: 6px;
}
.showing-calendar-container .calendars .sb-fc .fc-ltr .fc-axis {
  text-align: center;
  color: #808080;
}
.showing-calendar-container .calendars .sb-fc .fc-daygrid-day-number {
  padding: 5px 8px;
  font-size: 10px;
  line-height: 14px;
  color: var(--secondary-color-1);
}
.showing-calendar-container .calendars .sb-fc .fc-daygrid-more-link.fc-more-link {
  background-color: var(--primary-color-1);
  margin-top: 3px;
  width: 100%;
  padding: 4px 12px;
  border-radius: 8px;
  display: block;
  font-weight: 700;
  color: white;
  font-size: 8px;
}
.showing-calendar-container .calendars .sb-fc .fc-timegrid-more-link {
  height: -moz-fit-content;
  height: fit-content;
  background-color: var(--primary-color-1);
  font-weight: 700;
  color: white;
  font-size: 8px;
  padding: 2px 4px;
  border-radius: 4px;
}
.showing-calendar-container .calendars .sb-fc .fc .fc-day-today {
  background-color: white;
}
.showing-calendar-container .calendars .sb-fc .fc .fc-day-today .fc-daygrid-day-top .fc-daygrid-day-number {
  background-color: var(--primary-color-1);
  color: white;
  font-weight: 700;
  border-radius: 8px;
}
.showing-calendar-container .calendars .sb-fc .fc-popover {
  border-radius: 12px;
  box-shadow: 0px 5px 20px 0px rgba(42, 42, 42, 0.1);
  overflow: hidden;
}
.showing-calendar-container .calendars .sb-fc .fc-popover .fc-popover-header {
  background-color: white;
  color: var(--secondary-color-1);
  font-weight: 600;
  font-size: 12px;
  padding: 16px 16px 8px 16px;
}
.showing-calendar-container .calendars .sb-fc .fc-popover .fc-popover-body {
  display: flex;
  flex-direction: column;
  row-gap: 4px;
  padding: 4px;
}
.showing-calendar-container .calendars .sb-fc .fc-daygrid-event .event {
  position: relative;
  height: 40px;
}
.showing-calendar-container .calendars .sb-fc .event {
  border: 0.5px solid white;
  padding: 8px;
  color: var(--secondary-color-3);
  min-height: 40px;
  border-radius: 8px;
  display: flex;
  width: 100%;
  align-items: center;
  margin: 0;
}
.showing-calendar-container .calendars .sb-fc .event .fc-event-main {
  width: 100%;
}
.showing-calendar-container .calendars .sb-fc .event::before {
  display: block;
  content: "";
  position: absolute;
  width: 3px;
  border-radius: 50px;
  height: 20px;
  left: 4px;
  top: 8px;
}
.showing-calendar-container .calendars .sb-fc .event:focus::before {
  display: block;
  content: "";
  position: absolute;
  width: 3px;
  border-radius: 50px;
  height: 20px;
  top: auto;
  bottom: auto;
  left: 4px;
}
.showing-calendar-container .calendars .sb-fc .event:focus::after {
  background: none;
}
.showing-calendar-container .calendars .sb-fc .event.event {
  background: #ffffff;
  border-color: #357DED;
  cursor: pointer;
  transition: 0.2s ease-in-out;
}
.showing-calendar-container .calendars .sb-fc .event.event:hover {
  opacity: 0.75;
}
.showing-calendar-container .calendars .sb-fc .event.event::before {
  background-color: #357DED;
}
.showing-calendar-container .calendars .sb-fc .event.event.current {
  border-color: var(--primary-color-1);
  background-color: white;
}
.showing-calendar-container .calendars .sb-fc .event.event.current::before {
  background-color: var(--primary-color-1);
}
.showing-calendar-container .calendars .sb-fc .event.event.showing-draft {
  border-color: #F8A728;
}
.showing-calendar-container .calendars .sb-fc .event.event.showing-draft::before {
  background-color: #F8A728;
}
.showing-calendar-container .calendars .sb-fc .event.event.pending {
  border-color: #06C0CD;
}
.showing-calendar-container .calendars .sb-fc .event.event.pending::before {
  background-color: #06C0CD;
}
.showing-calendar-container .calendars .sb-fc .event.event.rejected {
  border-color: #FF3535;
}
.showing-calendar-container .calendars .sb-fc .event.event.rejected::before {
  background-color: #FF3535;
}
.showing-calendar-container .calendars .sb-fc .event.event.approved {
  border-color: #357DED;
}
.showing-calendar-container .calendars .sb-fc .event.event.approved::before {
  background-color: #357DED;
}
.showing-calendar-container .calendars .sb-fc .event.event.finished {
  border-color: #36C313;
}
.showing-calendar-container .calendars .sb-fc .event.event.finished::before {
  background-color: #36C313;
}
.showing-calendar-container .calendars .sb-fc .event.event.cancelled {
  border-color: #484848;
}
.showing-calendar-container .calendars .sb-fc .event.event.cancelled::before {
  background-color: #484848;
}
.showing-calendar-container .calendars .sb-fc .event.event.ongoing {
  border-color: #CE1FFA;
}
.showing-calendar-container .calendars .sb-fc .event.event.ongoing::before {
  background-color: #CE1FFA;
}
.showing-calendar-container .calendars .sb-fc .event.blackout {
  background-color: #EBEBEB;
  border-color: #949494;
}
.showing-calendar-container .calendars .sb-fc .event.blackout::before {
  background-color: #949494;
}
.showing-calendar-container .calendars .sb-fc .event.open_house {
  background-color: #EFDFF7;
}
.showing-calendar-container .calendars .sb-fc .event.open_house::before {
  background-color: #B15DD9;
}
.showing-calendar-container .calendars .sb-fc .event .fc-event-title {
  text-transform: capitalize;
  font-weight: 700;
  font-size: 8px;
  color: var(--secondary-color-1);
}
.showing-calendar-container .calendars .sb-fc .fc-content {
  position: relative;
  height: 100%;
}
.showing-calendar-container .calendars .sb-fc .fc-content .fc-time {
  position: absolute;
  bottom: 0;
}
.showing-calendar-container .calendars .sb-fc .fc-event-time,
.showing-calendar-container .calendars .sb-fc .fc-event-title {
  color: #202020;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .showing-calendar-container .calendars {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0 20px;
  }
  .showing-calendar-container .calendars .sb-fc table > thead {
    font-size: 12px !important;
  }
  .showing-calendar-container .calendars .sb-fc .fc .fc-header-toolbar .fc-toolbar-chunk:first-child .fc-button-group {
    display: none;
  }
  .showing-calendar-container .calendars .sb-fc .fc-toolbar-title {
    font-size: 16px;
  }
  .showing-calendar-container .calendars .sb-fc .fc-timegrid-event .fc-event-time {
    white-space: normal;
  }
  .showing-calendar-container .calendars .sb-fc-mini {
    margin-top: 30px;
  }
  .showing-calendar-container .calendars .sb-fc-mini .fc-theme-standard {
    display: none;
  }
  .showing-calendar-container .calendars .sb-fc-mini .selected-showing {
    font-family: "Proxima Nova", sans-serif;
  }
  .showing-calendar-container .calendars .sb-fc-mini .selected-showing p.title {
    font-weight: 700;
    font-size: 25px;
    color: var(--secondary-color-3);
    margin: 0;
  }
  .showing-calendar-container .calendars .sb-fc-mini .selected-showing .showing-schedule {
    display: flex;
    justify-content: space-between;
  }
  .showing-calendar-container .calendars .sb-fc-mini .selected-showing .showing-schedule .date,
  .showing-calendar-container .calendars .sb-fc-mini .selected-showing .showing-schedule .time {
    margin: 0;
    font-size: 20px;
  }
  .showing-calendar-container .calendars .sb-fc-mini .selected-showing .showing-schedule .date {
    font-weight: 700;
    color: var(--secondary-color-1);
  }
  .showing-calendar-container .calendars .sb-fc-mini .selected-showing .showing-schedule .time {
    font-weight: 600;
    color: var(--primary-color-1);
  }
}
@media (min-width: 768px) and (max-width: 1024px), (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
  .showing-calendar-container .calendars {
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0 20px;
  }
  .showing-calendar-container .calendars .sb-fc table > thead {
    font-size: 12px !important;
  }
  .showing-calendar-container .calendars .sb-fc .fc .fc-header-toolbar .fc-toolbar-chunk:first-child .fc-button-group {
    display: none;
  }
  .showing-calendar-container .calendars .sb-fc .fc-toolbar-title {
    font-size: 16px;
  }
  .showing-calendar-container .calendars .sb-fc .fc-timegrid-event .fc-event-time {
    white-space: normal;
  }
  .showing-calendar-container .calendars .sb-fc-mini {
    margin-top: 30px;
  }
  .showing-calendar-container .calendars .sb-fc-mini .fc-theme-standard {
    display: none;
  }
  .showing-calendar-container .calendars .sb-fc-mini .selected-showing {
    font-family: "Proxima Nova", sans-serif;
  }
  .showing-calendar-container .calendars .sb-fc-mini .selected-showing p.title {
    font-weight: 700;
    font-size: 25px;
    color: var(--secondary-color-3);
    margin: 0;
  }
  .showing-calendar-container .calendars .sb-fc-mini .selected-showing .showing-schedule {
    display: flex;
    justify-content: space-between;
  }
  .showing-calendar-container .calendars .sb-fc-mini .selected-showing .showing-schedule .date,
  .showing-calendar-container .calendars .sb-fc-mini .selected-showing .showing-schedule .time {
    margin: 0;
    font-size: 20px;
  }
  .showing-calendar-container .calendars .sb-fc-mini .selected-showing .showing-schedule .date {
    font-weight: 700;
    color: var(--secondary-color-1);
  }
  .showing-calendar-container .calendars .sb-fc-mini .selected-showing .showing-schedule .time {
    font-weight: 600;
    color: var(--primary-color-1);
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/ShowingRequest/modules/Calendar/modules/CalendarView/calendarView.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAGA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uCAAA;EACA,sBAAA;AAFJ;AAII;EACI,aAAA;EACA,mBAAA;AAFR;AAIQ;EACI,SAAA;EACA,uCAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;EACA,iBAAA;AAFZ;AAMI;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AAJR;AAMQ;EACI,uCAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,+BAAA;AAJZ;AAMY;EACI,gBAAA;EACA,0BAAA;AAJhB;AAMgB;EACI,cAAA;AAJpB;AAOgB;EACI,+BAAA;AALpB;AAWI;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;AATR;AAWQ;EACI,UAAA;EACA,WAAA;EACA,UAAA;AATZ;AAaQ;EAKI,UAAA;EAKA,WAAA;EAMA,oBAAA;AAxBZ;AASY;EACI,UAAA;AAPhB;AAWY;EACI,mBAAA;AAThB;AAaY;EACI,mBAAA;EACA,mBAAA;AAXhB;AAeY;EACI,mBAAA;AAbhB;AAiBQ;EACI,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,SAAA;EACA,YAAA;AAfZ;AAkBQ;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AAhBZ;AAkBY;EACI,cAAA;EACA,SAAA;EACA,eAAA;AAhBhB;AAmBY;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,+BAAA;AAjBhB;AAqBQ;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,4BAAA;AAnBZ;AAqBY;EACI,YAAA;AAnBhB;AAwBI;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;EACA,uCAAA;EACA,uBAAA;AAtBR;AAuBQ;EACI,8DAAA;AArBZ;AAuBQ;EACI,aAAA;EACA,YAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AArBZ;AAuBY;EACI,gBAAA;EACA,eAAA;EACA,SAAA;AArBhB;AAwBY;EACI,eAAA;EACA,4BAAA;AAtBhB;AAwBgB;EACI,aAAA;AAtBpB;AA0BY;EACI,aAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;AAxBhB;AA0BgB;EACI,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,4BAAA;AAxBpB;AA0BoB;EACI,aAAA;AAxBxB;AA2BoB;EACI,wCAAA;EACA,YAAA;EACA,gBAAA;AAzBxB;AA+BQ;EACI,2BAAA;EACA,kBAAA;AA7BZ;AA+BY;EACI,2BAAA;EACA,WAAA;EACA,YAAA;EACA,kDAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AA7BhB;AAgCY;EACI,YAAA;AA9BhB;AAgCgB;EACI,sBAAA;AA9BpB;AAkCY;EACI,gBAAA;EACA,YAAA;AAhChB;AAmCY;EACI,cAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAjChB;AAoCY;EACI,eAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;AAlChB;AAqCY;EACI,qBAAA;EACA,6BAAA;EACA,gCAAA;EACA,gBAAA;EACA,2BAAA;AAnChB;AAsCY;EACI,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AApChB;AAsCgB;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,oBAAA;EACA,yBAAA;AApCpB;AAwCY;EACI,yBAAA;EACA,mBAAA;AAtChB;AAyCY;EACI,yBAAA;EACA,gBAAA;EACA,YAAA;AAvChB;AA0CY;EACI,iBAAA;AAxChB;AA2CY;EACI,mBAAA;AAzChB;AA4CY;EACI,eAAA;EACA,uBAAA;AA1ChB;AA6CY;EACI,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,4BAAA;AA3ChB;AA8CY;EACI,gBAAA;EACA,iBAAA;EACA,mBAAA;AA5ChB;AAgDY;EACI,uBAAA;AA9ChB;AAiDY;EACI,cAAA;EACA,eAAA;AA/ChB;AAkDY;;EAEI,mBAAA;EACA,SAAA;EACA,YAAA;AAhDhB;AAmDY;EACI,mBAAA;EACA,cAAA;EACA,8BAAA;EACA,SAAA;EACA,iBAAA;EACA,0BAAA;EACA,iBAAA;EACA,4BAAA;AAjDhB;AAoDY;EACI,YAAA;AAlDhB;AAqDY;EACI,mBAAA;AAnDhB;AAsDY;EACI,cAAA;AApDhB;AAuDY;EACI,kBAAA;AArDhB;AAwDY;EACI,YAAA;AAtDhB;AAyDY;EACI,aAAA;AAvDhB;AA0DY;;EAEI,gBAAA;AAxDhB;AA2DY;EACI,iBAAA;AAzDhB;AA4DY;EACI,kBAAA;EACA,cAAA;AA1DhB;AA6DY;EACI,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,+BAAA;AA3DhB;AA8DY;EACI,wCAAA;EACA,eAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;AA5DhB;AA+DY;EACI,wBAAA;EAAA,mBAAA;EACA,wCAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AA7DhB;AAgEY;EACI,uBAAA;AA9DhB;AAiEoB;EACI,wCAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;AA/DxB;AAqEY;EACI,mBAAA;EACA,kDAAA;EACA,gBAAA;AAnEhB;AAqEgB;EACI,uBAAA;EACA,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,2BAAA;AAnEpB;AAsEgB;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;AApEpB;AAyEgB;EACI,kBAAA;EACA,YAAA;AAvEpB;AA2EY;EACI,yBAAA;EACA,YAAA;EACA,+BAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,WAAA;EACA,mBAAA;EACA,SAAA;AAzEhB;AA2EgB;EACI,WAAA;AAzEpB;AA4EgB;EACI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;AA1EpB;AA6EgB;EACI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;EACA,SAAA;AA3EpB;AA8EgB;EACI,gBAAA;AA5EpB;AA+EgB;EACI,mBAAA;EACA,qBAAA;EACA,eAAA;EACA,4BAAA;AA7EpB;AA+EoB;EACI,aAAA;AA7ExB;AAgFoB;EACI,yBAAA;AA9ExB;AAgFoB;EACI,oCAAA;EACA,uBAAA;AA9ExB;AA+EwB;EACI,wCAAA;AA7E5B;AAgFoB;EACI,qBAAA;AA9ExB;AA+EwB;EACI,yBAAA;AA7E5B;AAgFoB;EACI,qBAAA;AA9ExB;AAgFwB;EACI,yBAAA;AA9E5B;AAkFoB;EACI,qBAAA;AAhFxB;AAkFwB;EACI,yBAAA;AAhF5B;AAoFoB;EACI,qBAAA;AAlFxB;AAoFwB;EACI,yBAAA;AAlF5B;AAsFoB;EACI,qBAAA;AApFxB;AAsFwB;EACI,yBAAA;AApF5B;AAwFoB;EACI,qBAAA;AAtFxB;AAwFwB;EACI,yBAAA;AAtF5B;AA0FoB;EACI,qBAAA;AAxFxB;AA0FwB;EACI,yBAAA;AAxF5B;AA6FgB;EACI,yBAAA;EACA,qBAAA;AA3FpB;AA4FoB;EACI,yBAAA;AA1FxB;AA8FgB;EACI,yBAAA;AA5FpB;AA8FoB;EACI,yBAAA;AA5FxB;AAgGgB;EACI,0BAAA;EACA,gBAAA;EACA,cAAA;EACA,+BAAA;AA9FpB;AAkGY;EACI,kBAAA;EACA,YAAA;AAhGhB;AAmGY;EACI,kBAAA;EACA,SAAA;AAjGhB;AAoGY;;EAEI,cAAA;AAlGhB;AAuGI;EACI;IACI,UAAA;EArGV;EAwGM;IACI,UAAA;EAtGV;AACF;;ACjfY;ED8lBJ;IACI,aAAA;IACA,sBAAA;IACA,WAAA;IACA,eAAA;EAzGV;EA4Gc;IACI,0BAAA;EA1GlB;EA6Gc;IACI,aAAA;EA3GlB;EA8Gc;IACI,eAAA;EA5GlB;EA+Gc;IACI,mBAAA;EA7GlB;EAiHU;IACI,gBAAA;EA/Gd;EAiHc;IACI,aAAA;EA/GlB;EAkHc;IACI,uCAAA;EAhHlB;EAkHkB;IACI,gBAAA;IACA,eAAA;IACA,+BAAA;IACA,SAAA;EAhHtB;EAmHkB;IACI,aAAA;IACA,8BAAA;EAjHtB;EAmHsB;;IAEI,SAAA;IACA,eAAA;EAjH1B;EAoHsB;IACI,gBAAA;IACA,+BAAA;EAlH1B;EAqHsB;IACI,gBAAA;IACA,6BAAA;EAnH1B;AACF;AC/hBY;EDulBJ;IACI,aAAA;IACA,sBAAA;IACA,WAAA;IACA,eAAA;EArDV;EAwDc;IACI,0BAAA;EAtDlB;EAyDc;IACI,aAAA;EAvDlB;EA0Dc;IACI,eAAA;EAxDlB;EA2Dc;IACI,mBAAA;EAzDlB;EA6DU;IACI,gBAAA;EA3Dd;EA6Dc;IACI,aAAA;EA3DlB;EA8Dc;IACI,uCAAA;EA5DlB;EA8DkB;IACI,gBAAA;IACA,eAAA;IACA,+BAAA;IACA,SAAA;EA5DtB;EA+DkB;IACI,aAAA;IACA,8BAAA;EA7DtB;EA+DsB;;IAEI,SAAA;IACA,eAAA;EA7D1B;EAgEsB;IACI,gBAAA;IACA,+BAAA;EA9D1B;EAiEsB;IACI,gBAAA;IACA,6BAAA;EA/D1B;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\r\n\r\n\r\n.showing-calendar-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    font-family: 'Proxima Nova', sans-serif;\r\n    animation: fadeIn .5s;\r\n\r\n    .header {\r\n        display: flex;\r\n        align-items: center;\r\n\r\n        >p {\r\n            margin: 0;\r\n            font-family: 'Proxima Nova', sans-serif;\r\n            font-weight: 700;\r\n            color: var(--secondary-color-1);\r\n            font-size: 20px;\r\n            margin-left: 10px;\r\n        }\r\n    }\r\n\r\n    .info {\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n\r\n        >p {\r\n            font-family: 'Proxima Nova', sans-serif;\r\n            font-size: 16px;\r\n            line-height: 24px;\r\n            width: 800px;\r\n            text-align: center;\r\n            color: var(--secondary-color-1);\r\n\r\n            >span {\r\n                font-weight: 700;\r\n                text-decoration: underline;\r\n\r\n                &.showing {\r\n                    color: #FAC91F;\r\n                }\r\n\r\n                &.blackout {\r\n                    color: var(--secondary-color-3);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .event-container {\r\n        height: 100%;\r\n        width: 100%;\r\n        display: flex;\r\n        justify-content: space-between;\r\n        column-gap: 4px;\r\n\r\n        ::-webkit-scrollbar {\r\n            width: 5px;\r\n            height: 5px;\r\n            opacity: 0;\r\n        }\r\n        \r\n\r\n        &:hover {\r\n            ::-webkit-scrollbar {\r\n                opacity: 1;\r\n            }\r\n\r\n            /* Track */\r\n            ::-webkit-scrollbar-track {\r\n                border-radius: 10px;\r\n            }\r\n\r\n            /* Handle */\r\n            ::-webkit-scrollbar-thumb {\r\n                background: #b4b4b4;\r\n                border-radius: 10px;\r\n            }\r\n\r\n            /* Handle on hover */\r\n            ::-webkit-scrollbar-thumb:hover {\r\n                background: #b4b4b4;\r\n            }\r\n        }\r\n\r\n        .indicators {\r\n            display: flex;\r\n            align-items: center;\r\n            flex-direction: column;\r\n            bottom: 0;\r\n            row-gap: 2px;\r\n        }\r\n\r\n        .event-bubble {\r\n            display: flex;\r\n            flex-direction: column;\r\n            height: 100%;\r\n            overflow: auto;\r\n            position: relative;\r\n            row-gap: 4px;\r\n            padding-left: 8px;\r\n\r\n            .time {\r\n                color: #5F5F5F;\r\n                margin: 0;\r\n                font-size: 12px;\r\n            }\r\n\r\n            .detail {\r\n                width: 100%;\r\n                font-size: 12px;\r\n                font-weight: 700;\r\n                text-transform: capitalize;\r\n                color: var(--secondary-color-1);\r\n            }\r\n        }\r\n\r\n        .view {\r\n            position: absolute;\r\n            top: 3px;\r\n            right: 2px;\r\n            cursor: pointer;\r\n            transition: .2s ease-in-out;\r\n\r\n            &:hover {\r\n                opacity: .5;\r\n            }\r\n        }\r\n    }\r\n\r\n    .calendars {\r\n        display: flex;\r\n        flex-direction: column;\r\n        width: 100%;\r\n        padding: 0px;\r\n        font-family: 'Proxima Nova', sans-serif;\r\n        background-color: white;\r\n        .past-cell {\r\n            background-color: #fef2f24b !important;\r\n        }\r\n        .custom-toolbar {\r\n            display: flex;\r\n            height: 60px;\r\n            justify-content: space-between;\r\n            align-items: center;\r\n            padding-right: 24px;\r\n\r\n            .title {\r\n                font-weight: 700;\r\n                font-size: 16px;\r\n                margin: 0;\r\n            }\r\n\r\n            svg {\r\n                cursor: pointer;\r\n                transition: .2s ease-in-out;\r\n\r\n                &:hover {\r\n                    opacity: .75;\r\n                }\r\n            }\r\n\r\n            .views {\r\n                display: flex;\r\n                padding: 4px;\r\n                border-radius: 8px;\r\n                background-color: #F9F9F9;\r\n                font-size: 10px;\r\n                font-weight: 400;\r\n\r\n                >li {\r\n                    width: 78px;\r\n                    border-radius: 4px;\r\n                    background-color: inherit;\r\n                    padding: 8px 0;\r\n                    text-align: center;\r\n                    cursor: pointer;\r\n                    transition: .2s ease-in-out;\r\n\r\n                    &:hover {\r\n                        opacity: .75;\r\n                    }\r\n\r\n                    &.active {\r\n                        background-color: var(--primary-color-1);\r\n                        color: white;\r\n                        font-weight: 700;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        .sb-fc {\r\n            height: calc(100vh - 140px);\r\n            position: relative;\r\n\r\n            .loading {\r\n                height: calc(100vh - 140px);\r\n                width: 100%;\r\n                z-index: 999;\r\n                background-color: #ffffff5e;\r\n                display: flex;\r\n                align-items: center;\r\n                justify-content: center;\r\n                position: absolute;\r\n            }\r\n\r\n            table>thead {\r\n                height: 54px;\r\n\r\n                >tr>th {\r\n                    vertical-align: middle;\r\n                }\r\n            }\r\n\r\n            .fc .fc-scrollgrid {\r\n                overflow: hidden;\r\n                border: none;\r\n            }\r\n\r\n            .fc-daygrid-day-events {\r\n                padding: 0 4px;\r\n                display: flex;\r\n                flex-direction: column;\r\n                row-gap: 3px;\r\n            }\r\n\r\n            .fc .fc-timegrid-slot-label-cushion {\r\n                font-size: 12px;\r\n                text-transform: uppercase;\r\n                color: #949494;\r\n                font-weight: 700;\r\n            }\r\n\r\n            .fc .fc-timegrid-now-indicator-arrow {\r\n                border-color: #EF4546;\r\n                border-top-color: transparent;\r\n                border-bottom-color: transparent;\r\n                margin-top: -6px;\r\n                border-width: 7px 0 7px 8px;\r\n            }\r\n\r\n            .fc .fc-timegrid-now-indicator-line {\r\n                border-color: #EF4546;\r\n                border-width: 2px 0 0;\r\n                position: relative;\r\n                display: flex;\r\n                align-items: center;\r\n\r\n                &::before {\r\n                    content: \"\";\r\n                    position: absolute;\r\n                    height: 8px;\r\n                    width: 8px;\r\n                    border-radius: 100px;\r\n                    background-color: #EF4546;\r\n                }\r\n            }\r\n\r\n            .fc-theme-standard th {\r\n                border: 1px solid #F5F5F5;\r\n                border-bottom: none;\r\n            }\r\n\r\n            .fc-theme-standard td {\r\n                border: 1px solid #F5F5F5;\r\n                border-top: none;\r\n                height: 40px;\r\n            }\r\n\r\n            .fc td.fc-day-disabled {\r\n                background: white;\r\n            }\r\n\r\n            .fc th.fc-day-disabled {\r\n                background: #F5F5F5;\r\n            }\r\n\r\n            .fc .fc-daygrid-day-top {\r\n                padding: 10px 0;\r\n                justify-content: center;\r\n            }\r\n\r\n            .fc-left>.fc-button-group {\r\n                background: #FFFFFF;\r\n                padding: 5px 2px;\r\n                border: 1px solid #FAC91F;\r\n                border-radius: 10px;\r\n                align-content: space-between;\r\n            }\r\n\r\n            .fc .fc-header-toolbar .fc-toolbar-chunk:first-child .fc-button-group {\r\n                padding: 4px 5px;\r\n                background: white;\r\n                border-radius: 10px;\r\n            }\r\n\r\n            // .fc-toolbar-title { color: white; }\r\n            .fc-toolbar.fc-header-toolbar {\r\n                background-color: white;\r\n            }\r\n\r\n            .fc-center h2 {\r\n                color: #FFFFFF;\r\n                font-size: 25px;\r\n            }\r\n\r\n            .fc-button-primary:not(:disabled).fc-button-active,\r\n            .fc-button-primary:not(:disabled):active {\r\n                background: #FAC91F;\r\n                border: 0;\r\n                color: white;\r\n            }\r\n\r\n            .fc-button-group>.fc-button {\r\n                background: #FFFFFF;\r\n                color: #BEBEBE;\r\n                border-radius: 10px !important;\r\n                border: 0;\r\n                font-weight: bold;\r\n                text-transform: capitalize;\r\n                padding: 6px 18px;\r\n                transition: .3s ease-in-out;\r\n            }\r\n\r\n            .fc-right>.fc-button-group>.fc-button {\r\n                padding: 7px;\r\n            }\r\n\r\n            .fc-right>.fc-button-group>.fc-button-primary {\r\n                background: #FFFFFF;\r\n            }\r\n\r\n            .fc-right>.fc-button-group>.fc-button-primary:disabled {\r\n                color: #BEBEBE;\r\n            }\r\n\r\n            .fc-prev-button {\r\n                margin-right: 20px;\r\n            }\r\n\r\n            .fc-right .fc-button:disabled {\r\n                opacity: 0.30;\r\n            }\r\n\r\n            .fc-right .fc-button {\r\n                opacity: 0.65;\r\n            }\r\n\r\n            .fc-button-primary:not(:disabled).fc-button-active:focus,\r\n            .fc-button-primary:not(:disabled):active:focus {\r\n                box-shadow: none;\r\n            }\r\n\r\n            .fc-button-group>.fc-button:not(:last-child) {\r\n                margin-right: 6px;\r\n            }\r\n\r\n            .fc-ltr .fc-axis {\r\n                text-align: center;\r\n                color: #808080;\r\n            }\r\n\r\n            .fc-daygrid-day-number {\r\n                padding: 5px 8px;\r\n                font-size: 10px;\r\n                line-height: 14px;\r\n                color: var(--secondary-color-1);\r\n            }\r\n\r\n            .fc-daygrid-more-link.fc-more-link {\r\n                background-color: var(--primary-color-1);\r\n                margin-top: 3px;\r\n                width: 100%;\r\n                padding: 4px 12px;\r\n                border-radius: 8px;\r\n                display: block;\r\n                font-weight: 700;\r\n                color: white;\r\n                font-size: 8px;\r\n            }\r\n\r\n            .fc-timegrid-more-link {\r\n                height: fit-content;\r\n                background-color: var(--primary-color-1);\r\n                font-weight: 700;\r\n                color: white;\r\n                font-size: 8px;\r\n                padding: 2px 4px;\r\n                border-radius: 4px;\r\n            }\r\n\r\n            .fc .fc-day-today {\r\n                background-color: white;\r\n\r\n                .fc-daygrid-day-top {\r\n                    .fc-daygrid-day-number {\r\n                        background-color: var(--primary-color-1);\r\n                        color: white;\r\n                        font-weight: 700;\r\n                        border-radius: 8px;\r\n                    }\r\n                }\r\n\r\n            }\r\n\r\n            .fc-popover {\r\n                border-radius: 12px;\r\n                box-shadow: 0px 5px 20px 0px rgba(42, 42, 42, 0.10);\r\n                overflow: hidden;\r\n\r\n                .fc-popover-header {\r\n                    background-color: white;\r\n                    color: var(--secondary-color-1);\r\n                    font-weight: 600;\r\n                    font-size: 12px;\r\n                    padding: 16px 16px 8px 16px;\r\n                }\r\n\r\n                .fc-popover-body {\r\n                    display: flex;\r\n                    flex-direction: column;\r\n                    row-gap: 4px;\r\n                    padding: 4px;\r\n                }\r\n            }\r\n\r\n            .fc-daygrid-event {\r\n                .event {\r\n                    position: relative;\r\n                    height: 40px;\r\n                }\r\n            }\r\n\r\n            .event {\r\n                border: 0.5px solid white;\r\n                padding: 8px;\r\n                color: var(--secondary-color-3);\r\n                min-height: 40px;\r\n                border-radius: 8px;\r\n                display: flex;\r\n                width: 100%;\r\n                align-items: center;\r\n                margin: 0;\r\n\r\n                .fc-event-main {\r\n                    width: 100%;\r\n                }\r\n\r\n                &::before {\r\n                    display: block;\r\n                    content: \"\";\r\n                    position: absolute;\r\n                    width: 3px;\r\n                    border-radius: 50px;\r\n                    height: 20px;\r\n                    left: 4px;\r\n                    top: 8px;\r\n                }\r\n\r\n                &:focus::before {\r\n                    display: block;\r\n                    content: \"\";\r\n                    position: absolute;\r\n                    width: 3px;\r\n                    border-radius: 50px;\r\n                    height: 20px;\r\n                    top: auto;\r\n                    bottom: auto;\r\n                    left: 4px;\r\n                }\r\n\r\n                &:focus::after {\r\n                    background: none;\r\n                }\r\n\r\n                &.event {\r\n                    background: #ffffff;\r\n                    border-color: #357DED;\r\n                    cursor: pointer;\r\n                    transition: .2s ease-in-out;\r\n\r\n                    &:hover {\r\n                        opacity: .75;\r\n                    }\r\n\r\n                    &::before {\r\n                        background-color: #357DED;\r\n                    }\r\n                    &.current {\r\n                        border-color: var(--primary-color-1);\r\n                        background-color: white;\r\n                        &::before {\r\n                            background-color: var(--primary-color-1);\r\n                        }\r\n                    }\r\n                    &.showing-draft {\r\n                        border-color: #F8A728;\r\n                        &::before {\r\n                            background-color: #F8A728;\r\n                        }\r\n                    }\r\n                    &.pending {\r\n                        border-color: #06C0CD;\r\n\r\n                        &::before {\r\n                            background-color: #06C0CD;\r\n                        }\r\n                    }\r\n\r\n                    &.rejected {\r\n                        border-color: #FF3535;\r\n\r\n                        &::before {\r\n                            background-color: #FF3535;\r\n                        }\r\n                    }\r\n\r\n                    &.approved {\r\n                        border-color: #357DED;\r\n\r\n                        &::before {\r\n                            background-color: #357DED;\r\n                        }\r\n                    }\r\n\r\n                    &.finished {\r\n                        border-color: #36C313;\r\n\r\n                        &::before {\r\n                            background-color: #36C313;\r\n                        }\r\n                    }\r\n\r\n                    &.cancelled {\r\n                        border-color: #484848;\r\n\r\n                        &::before {\r\n                            background-color: #484848;\r\n                        }\r\n                    }\r\n\r\n                    &.ongoing {\r\n                        border-color: #CE1FFA;\r\n\r\n                        &::before {\r\n                            background-color: #CE1FFA;\r\n                        }\r\n                    }\r\n                }\r\n\r\n                &.blackout {\r\n                    background-color: #EBEBEB;\r\n                    border-color: #949494;\r\n                    &::before {\r\n                        background-color: #949494;\r\n                    }\r\n                }\r\n\r\n                &.open_house {\r\n                    background-color: #EFDFF7;\r\n\r\n                    &::before {\r\n                        background-color: #B15DD9;\r\n                    }\r\n                }\r\n\r\n                .fc-event-title {\r\n                    text-transform: capitalize;\r\n                    font-weight: 700;\r\n                    font-size: 8px;\r\n                    color: var(--secondary-color-1);\r\n                }\r\n            }\r\n\r\n            .fc-content {\r\n                position: relative;\r\n                height: 100%;\r\n            }\r\n\r\n            .fc-content .fc-time {\r\n                position: absolute;\r\n                bottom: 0;\r\n            }\r\n\r\n            .fc-event-time,\r\n            .fc-event-title {\r\n                color: #202020;\r\n            }\r\n        }\r\n    }\r\n\r\n    @keyframes fadeIn {\r\n        0% {\r\n            opacity: 0;\r\n        }\r\n\r\n        100% {\r\n            opacity: 1;\r\n        }\r\n    }\r\n}\r\n\r\n@include media(mobile, tablet) {\r\n\r\n    .showing-calendar-container {\r\n        .calendars {\r\n            display: flex;\r\n            flex-direction: column;\r\n            width: 100%;\r\n            padding: 0 20px;\r\n\r\n            .sb-fc {\r\n                table>thead {\r\n                    font-size: 12px !important;\r\n                }\r\n\r\n                .fc .fc-header-toolbar .fc-toolbar-chunk:first-child .fc-button-group {\r\n                    display: none;\r\n                }\r\n\r\n                .fc-toolbar-title {\r\n                    font-size: 16px;\r\n                }\r\n\r\n                .fc-timegrid-event .fc-event-time {\r\n                    white-space: normal;\r\n                }\r\n            }\r\n\r\n            .sb-fc-mini {\r\n                margin-top: 30px;\r\n\r\n                .fc-theme-standard {\r\n                    display: none;\r\n                }\r\n\r\n                .selected-showing {\r\n                    font-family: 'Proxima Nova', sans-serif;\r\n\r\n                    p.title {\r\n                        font-weight: 700;\r\n                        font-size: 25px;\r\n                        color: var(--secondary-color-3);\r\n                        margin: 0;\r\n                    }\r\n\r\n                    .showing-schedule {\r\n                        display: flex;\r\n                        justify-content: space-between;\r\n\r\n                        .date,\r\n                        .time {\r\n                            margin: 0;\r\n                            font-size: 20px;\r\n                        }\r\n\r\n                        .date {\r\n                            font-weight: 700;\r\n                            color: var(--secondary-color-1);\r\n                        }\r\n\r\n                        .time {\r\n                            font-weight: 600;\r\n                            color: var(--primary-color-1);\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
